import JSEncrypt from 'jsencrypt/bin/jsencrypt'
import VueJwtDecode from 'vue-jwt-decode'
import { getAccessToken, groupChk, sellerInfo, getJoinCoupon, getAlertSetting, chkRsaKey } from '../../api/index'
import Axios from 'axios'

// 클립보드 텍스트 복사
export const textCopy = function (text) {
  return new Promise(async resolve => {
    let t = document.createElement('textarea')
    document.body.appendChild(t)
    t.value = text
    t.select()
    t.setSelectionRange(0, 99999)
    document.execCommand('copy')
    document.body.removeChild(t)
    resolve(true)
  })
}

/** RSA 암호화 */
export const makeRsa = async function (value) {
  return new Promise(async resolve => {
    const res = await chkRsaKey()
    if (res.data.jsonData.resultCode === '0001') {
      let encryptor = new JSEncrypt()
      encryptor.setPublicKey(res.data.jsonData.res.publicKey)
      let rsaEncStr = encryptor.encrypt(value)
      resolve(rsaEncStr)
    }
  })
}

// 날짜 String -> Date 변환
export const parseDate = function (str) {
  let string = str
  string = string.replace(/-/g, '')
  string = string.replace(/:/g, '')
  string = string.replace(/ /g, '')
  var y = string.substr(0, 4)
  var m = parseInt(string.substr(4, 2))
  var d = parseInt(string.substr(6, 2))
  var h = parseInt(string.substr(8, 2))
  var mm = parseInt(string.substr(10, 2))
  var ss = parseInt(string.substr(12, 2))
  return new Date(y, m - 1, d, h, mm, ss)
}

// jwt decode
export const jwtDecode = function (str) {
  return VueJwtDecode.decode(str)
}

// 토큰 만료 여부 확인 (true:만료 false:기한남음)
export const isTokenExpired = function (token, flag) {
  let tokenExp = VueJwtDecode.decode(token).exp * 1000 // 토큰 만료일
  let now = new Date().getTime() // 현재 시간
  let timeDiff = (tokenExp - now) / 1000 // 토큰의 남은 수명 (단위는 초)

  let iat = VueJwtDecode.decode(token).iat * 1000
  let result = ((tokenExp - iat) / 2) / 1000


  console.log(flag, ' : ', timeDiff)
  if (flag === 'accessToken') {
    if (timeDiff < 5) {
      return true
    } else {
      return false
    }
  } else {
    // 86400 => 1일
    if (timeDiff < 0) { // 30일 체크, 만료시 재로그인
      return 30
    } else if (timeDiff < result) { //  2주체크, 해당시 갱신
    // } else if (timeDiff < 40) { //  2주체크, 해당시 갱신
      return 14
    } else {
      return false
    }
  }
}

export const isEquals = function (x, y) { // 객체 값 동일 비교 함수
  if (x === y) return true
  if (!(x instanceof Object) || !(y instanceof Object)) return false
  if (x.constructor !== y.constructor) return false
  for (var p in x) {
    if (!x.hasOwnProperty(p)) continue
    if (!y.hasOwnProperty(p)) return false
    if (x[p] === y[p]) continue
    if (typeof (x[p]) !== 'object') return false
    if (!isEquals(x[p], y[p])) return false
  }
  for (p in y) {
    if (y.hasOwnProperty(p) && !x.hasOwnProperty(p)) return false
  }
  return true
}

export const isEmpty = function (str) {
  if (typeof str === 'undefined' || str === null || str === '') {
    return true
  } else {
    return false
  }
}

// 그룹체크 함수
// tokenType (string) = 'accessToken' or 'refreshToken'
export const groupSet = async function (groupId, token, tokenType) {
  if (tokenType === 'accessToken') {
    try {
      let res = await groupChk(token, groupId)
      if (res.data.jsonData.resultCode === '0001') {
        sessionStorage.setItem('setGroupChk', JSON.stringify({ id: groupId, flag: true }))
      } else {
        sessionStorage.setItem('setGroupChk', JSON.stringify({id: '0', flag: false}))
      }
    } catch (err) {
      console.log(err)
      // sessionStorage.setItem('setGroupChk', JSON.stringify({id: 0, flag: false}))
    }
  } else if (tokenType === 'refreshToken') {
    try {
      let res = await getAccessToken(token)
      // alert(res.data.jsonData.resultCode)
      // console.log(res)
      if (res.data.jsonData.resultCode === '0001') {
        sessionStorage.setItem('refreshToken', token)
        sessionStorage.setItem('accessToken', res.data.jsonData.accessToken)

        try {
          let gRes = await groupChk(res.data.jsonData.accessToken, groupId)
          if (gRes.data.jsonData.resultCode === '0001') {
            sessionStorage.setItem('setGroupChk', JSON.stringify({ id: groupId, flag: true }))
            // alert(sessionStorage.getItem('setGroupChk'))
          } else {
            sessionStorage.setItem('setGroupChk', JSON.stringify({id: '0', flag: false}))
          }
        } catch (err) {
          console.log(err)
        }

        this.$store.commit('authStore/updateIsLogin', true)
      }
    } catch (err) {
      console.error(err)
    }
  }
}

export const shortenStr = function(str, maxLength){
  if(str.length > maxLength){
    return str.substr(0, maxLength) + "..."
  }else{
    return str
  }
}





// 세션스토리지 암호화 (안전하지 않음! 사용자가 접근하기 불편하게 만드는 정도임.)
export const secureSS = {
  cryptoJS: require('crypto-js'),
  set(key, value) {
    value = JSON.stringify(value)

    let time = new Date().getTime().toString()

    let cipher = this.cryptoJS.AES.encrypt(value, time).toString() + '.' + this.cryptoJS.AES.encrypt(time, 'time').toString()
    cipher = this.cryptoJS.AES.encrypt(cipher, 'Shall2#.encrypt').toString()

    sessionStorage.setItem(key, cipher)
  },

  get(key) {
    let cipher = sessionStorage.getItem(key)
    if (!cipher) {
      return undefined
    }

    let bytes = this.cryptoJS.AES.decrypt(cipher, 'Shall2#.encrypt')
    let ciphers = bytes.toString(this.cryptoJS.enc.Utf8).split('.')
    let time = this.cryptoJS.AES.decrypt(ciphers[1], 'time').toString(this.cryptoJS.enc.Utf8)
    let origin = this.cryptoJS.AES.decrypt(ciphers[0], time).toString(this.cryptoJS.enc.Utf8)

    return JSON.parse(origin)
  },

  remove(key) {
    sessionStorage.removeItem(key)
  }
}

export const printBanner = function (version) {
  console.info()
}

export const sizeCheck = function (file, limit) {
  // limit는 MB 단위 입력
  let maxSize = limit * 1024 * 1024

  if (file.size > maxSize) {
    // alert(`동영상 업로드는 ${limit}MB 까지 가능합니다.`)
    return false
  } else {
    return true
  }
}

// 날짜 계산기
// limitDate로 받는 날짜의 형식은 'YYYY.MM.DD' 입니다.
export const dateCalc = function (limitDate) {
  let lDate = limitDate.split('.')
  let tDate = []
  let today = new Date()
  tDate.push(today.getFullYear())
  tDate.push(today.getMonth() + 1)
  tDate.push(today.getDate())
  let tD = new Date(tDate[0], tDate[1], tDate[2])
  let lD = new Date(parseInt(lDate[0]), parseInt(lDate[1]), parseInt(lDate[2]))
  let dif = lD - tD
  let diff = parseInt(dif / (24 * 60 * 60 * 1000))
  return diff
}

// 주민등록번호 유효성 체크
export const isValidJuminNo = function (socialRegNumber) {
  socialRegNumber = String(socialRegNumber)
  if (!socialRegNumber || socialRegNumber.length !== 13) {
    alert('주민등록번호 입력이 잘못되었습니다.')
    return false
  }
  if (isNaN(socialRegNumber)) {
    alert('주민등록번호 입력이 잘못되었습니다.')
    return false
  }
  let jumin1 = socialRegNumber.substr(0, 6)
  let jumin2 = socialRegNumber.substr(6, 7)
  let genda = jumin2.substr(0, 1) // 성별 1~4
  let formalYear = (genda < 3) ? '19' : '20' // 연도 계산 - 1 또는 2: 1900년대, 3 또는 4: 2000년대
  let yyyy = formalYear + jumin1.substr(0, 2)
  let MM = jumin1.substr(2, 2)
  let dd = jumin1.substr(4, 2) // 성별부분이 1 ~ 4 가 아닌 경우
  if (genda < 1 || genda > 4) {
    alert('주민등록번호 뒷자리를 다시 입력하세요.')
    return false
  } // 날짜 유효성 검사
  if (isValidDate(yyyy, MM, dd) === false) {
    alert('주민등록번호 앞자리를 다시 입력하세요.')
    return false
  } // Check Digit 검사
  if (!isSSN(jumin1, jumin2)) {
    alert('입력한 주민등록번호를 검토한 후, 다시 입력하세요.')
    return false
  }
  return true
}

// 날짜 포맷 유효성 체크
export const isValidDate = function (yyyy, MM, dd) {
  var oDate = new Date()
  oDate.setFullYear(parseInt(yyyy))
  oDate.setMonth(parseInt(MM) - 1)
  oDate.setDate(parseInt(dd))
  if (oDate.getFullYear() !== parseInt(yyyy) || oDate.getMonth() + 1 !== parseInt(MM) || oDate.getDate() !== parseInt(dd)) {
    return false
  } return true
}

// 주민번호 숫자형 유효성 체크
export const isSSN = function (jumin1, jumin2) {
  var n = 2; var sum = 0
  for (let i = 0; i < jumin1.length; i++) {
    sum += parseInt(jumin1.substr(i, 1)) * n++
  }
  for (let i = 0; i < jumin2.length - 1; i++) {
    sum += parseInt(jumin2.substr(i, 1)) * n++
    if (n === 10) { n = 2 }
  }
  var checkSum = 11 - sum % 11
  if (checkSum === 11) { checkSum = 1 }
  if (checkSum === 10) { checkSum = 0 }
  if (checkSum !== parseInt(jumin2.substr(6, 1))) {
    return false
  }
  return true
}


// 깊은 복사
export const deepClone = function(obj) {
  if(obj === null || typeof obj !== 'object') {
    return obj;
  }
  
  const result = Array.isArray(obj) ? [] : {};
  
  for(let key of Object.keys(obj)) {
    result[key] = deepClone(obj[key])
  }
  
  return result;
}


export const setState = function (info, type) {
  let { startDate, startTime, endTime, liveFlag, highlightUrl } = info

  let today = new Date()
  let year = today.getFullYear()
  let month = String(today.getMonth() + 1).length < 2 ? '0' + String(today.getMonth() + 1) : String(today.getMonth() + 1)
  let date = String(today.getDate()).length < 2 ? '0' + String(today.getDate()) : String(today.getDate())
  let fullDate = year + '-' + month + '-' + date

  let hour = String(today.getHours()).length < 2 ? '0' + String(today.getHours()) : String(today.getHours())
  let str = parseInt(startTime.substring(0, 2)) > 12 ? 'PM' : 'AM'
  let shortHour = parseInt(startTime.substring(0, 2)) > 12 ? parseInt(startTime.substring(0, 2)) - 12 : startTime.substring(0, 2)
  shortHour = String(shortHour).length < 2 ? '0' + String(shortHour) : String(shortHour)
  let min = String(today.getMinutes()).length < 2 ? '0' + String(today.getMinutes()) : String(today.getMinutes())
  let sec = String(today.getSeconds()).length < 2 ? '0' + String(today.getSeconds()) : String(today.getSeconds())
  let time = hour + ':' + min + ':' + sec



  if ((fullDate > startDate) || (fullDate === startDate && time > endTime)) {
    if (type === 'state') {
      if (highlightUrl) {
        return `지난방송 ${startDate.substring(5, 7)}.${startDate.substring(8, 10)} ${str} ${shortHour}:${startTime.substring(3, 5)}`
      } else {
        return `방송종료 ${startDate.substring(5, 7)}.${startDate.substring(8, 10)} ${str} ${shortHour}:${startTime.substring(3, 5)}`
      }
    } else if (type === 'boolean') {
      if (highlightUrl) {
        return 'vod'
      } else {
        return 'end'
      }
    }
  } else if ((fullDate < startDate) || (fullDate === startDate && time < startTime)) {
    if (type === 'state') {
      return `방송예정 ${startDate.substring(5, 7)}.${startDate.substring(8, 10)} ${str} ${shortHour}:${startTime.substring(3, 5)}`
    } else if (type === 'boolean') {
      return 'ready'
    }
  } else if ((fullDate === startDate && time > startTime) && (fullDate === startDate && time < endTime)) {
    if (liveFlag === 2 || liveFlag === 3) {
      if (type === 'state') {
        return `방송종료 ${startDate.substring(5, 7)}.${startDate.substring(8, 10)} ${str} ${shortHour}:${startTime.substring(3, 5)}`
      } else {
        return 'end'
      }
    }
    // this.liveIdx = index
    if (type === 'state') {
      return '방송중'
    } else if (type === 'boolean') {
      return 'ing'
    }
  }
}



// 이미지 압축 함수
export const imgCompress = function (source_img_obj, quality, maxWidth, output_format){
  let mime_type = "image/jpeg"
  if(typeof output_format !== "undefined" && output_format=="png"){
      mime_type = "image/png"
  }

  maxWidth = maxWidth || 1000
  let natW = source_img_obj.naturalWidth
  let natH = source_img_obj.naturalHeight
  let ratio = natH / natW
  if (natW > maxWidth) {
      natW = maxWidth
      natH = ratio * maxWidth
  }

  let cvs = document.createElement('canvas')
  cvs.width = natW
  cvs.height = natH

  let ctx = cvs.getContext("2d").drawImage(source_img_obj, 0, 0, natW, natH)
  let newImageData = cvs.toDataURL(mime_type, quality/100)
  let result_image_obj = new Image()
  result_image_obj.src = newImageData
  return result_image_obj
}


// 다이나믹링크 작성 함수
export const dynamicLink = function (link, title, description, thumbnail) {
  let linkStr = ''
  linkStr += `https://sellovelive1.page.link/?`
  linkStr += `link=${link}`
  linkStr += `&apn=com.sellove.service`
  linkStr += `isi=1582413821`
  linkStr += `ibi=com.sellove.service`
  linkStr += `&st=${encodeURI(title)}`
  linkStr += `&sd=${encodeURI(description)}`
  linkStr += `&si=${thumbnail}&efr=1`
  linkStr += `&afl=${link}`
  linkStr += `&ifl=${link}`
  linkStr += `&ofl=${link}`
  return linkStr
}

// 셀러버 권한 체크 함수
export const sellerCheck = async function (accessToken) {
  try {
    // if (sessionStorage.getItem('sally')) return false
    let sallyRes = await sellerInfo(accessToken)
    console.log('셀러버 체크 : ', sallyRes)
    if (sallyRes.data.jsonData.resultCode === '0001') {
      let info = {
        'sallySysId': sallyRes.data.jsonData.sallySysId,
        'sallyName': sallyRes.data.jsonData.sallyName,
        'badge': sallyRes.data.jsonData.liveBroadcastCnt + sallyRes.data.jsonData.terminatedCnt + sallyRes.data.jsonData.waitTotalCnt,
        'ctrCnt' : sallyRes.data.jsonData.terminatedCnt + sallyRes.data.jsonData.waitTotalCnt
      }
      sessionStorage.setItem('sally', JSON.stringify(info))
    } else {
      console.log('셀러버 체크 : 인증된 사용자가 아닙니다.')
      sessionStorage.removeItem('sally')
    }
  } catch (err) {
    console.log('셀러버 체크 : 인증된 사용자가 아닙니다.')
    sessionStorage.removeItem('sally')
  }
}

export const formatPrice = function (money) {
  return (money + '').replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

// url 체크해서 https로 만들어서 리턴 해주는 함수
export const urlChk = function (url) {
  if (url) {
    if (url.indexOf('http') === -1 && url.indexOf('https') === -1) {
      return 'https://' + url
    } else if (url.indexOf('https') > -1) {
      return url
    } else if (url.indexOf('http') > -1) {
      return url.replace('http', 'https')
    }
  }
}


// 요일 계산 함수 - date는 YYYY-MM-dd 의 형태로 문자열로 넣어줘야 함
export const printDay = function (date) {
  let d = new Date(date)
  let dd = d.getDay()
  return dd
}


// 파일 다운로드 함수 - url, fileName 
export const fnFileDown = function (url, name) {
  Axios({
    url: url,
    methods: "GET",
    responseType: "blob"
  }).then(response => {
      
      // let reader = new FileReader()
      // let out = new Blob([response.data], { type: 'application/octet-stream'})
      // reader.onload = function(e) {
      //   window.location.href = reader.result
      // }
      // reader.readAsDataURL(out)
      let fileUrl = window.URL.createObjectURL(new Blob([response.data]))
      // let fileUrl = window.URL.createObjectURL(out)
      let fileLink = document.createElement('a')
      
      fileLink.href = fileUrl
      fileLink.setAttribute('download', name)
      document.body.appendChild(fileLink)

      console.log(fileLink)
      fileLink.click()

      document.body.removeChild(fileLink)
      // window.URL.revokeObjectURL(fileLink)
  })
  .catch(err => {
    console.log(err)
  })
}


// 회원가입 쿠폰 정보 조회 함수
export const joinCoupon = async function (chkFlag) {
  let couponInfo = {
    discountAmount: 0
  }
  
  // 앱 일 경우 회원가입 유도 팝업 x
  const UA = navigator.userAgent.toLowerCase()
  if (UA.includes('native')) { return couponInfo }

  // 웹 일 경우 쿠폰 정보 및 유효날짜 체크 후 결과값 리턴
  let joinCouponRes = await getJoinCoupon()
  
  if (joinCouponRes.data.jsonData.resultCode === '0001') {
    let sd = joinCouponRes.data.jsonData.issuanceStartDate.split(' ')
    let ed = joinCouponRes.data.jsonData.issuanceEndDate.split(' ')
    let today = new Date()
    let stDate = new Date(sd[0].split('-')[0], (Number(sd[0].split('-')[1]) - 1), Number(sd[0].split('-')[2]), Number(sd[1].split(':')[0]), Number(sd[1].split(':')[1]) ,Number(sd[1].split(':')[2]) )
    let edDate = new Date(ed[0].split('-')[0], (Number(ed[0].split('-')[1]) - 1), Number(ed[0].split('-')[2]), Number(ed[1].split(':')[0]), Number(ed[1].split(':')[1]) ,Number(ed[1].split(':')[2]) )

    if (today >= stDate && today <= edDate && joinCouponRes.data.jsonData.isUse === 1) {
      couponInfo.discountAmount = joinCouponRes.data.jsonData.discountPolicyFigures
    }
  }

  return couponInfo
}

// 회원 알림 설정 조회
export const AlertChek = async function (accessToken) {
  try {
    let alertRes = await getAlertSetting(accessToken)
    console.log('알림 설정 조회 : ', alertRes)
    if (alertRes.data.jsonData.resultCode === '0001') {
      AppBridge.send('getPushSetting', {
        'coupon': alertRes.data.jsonData.couponPresentFlag,
        'event': alertRes.data.jsonData.eventFlag,
        'broadcast': alertRes.data.jsonData.liveBroadcastFlag,
        'order': alertRes.data.jsonData.orderFlag
      }, true)
    } else {
      console.log('알림 설정 체크에러')
    }
  } catch (err) {
    console.log('알림 설정 체크에러')
  }
}

// ****************************************************
// **********                                **********
// **********      안드로이드, IOS 브릿지       **********
// **********                                **********
// ****************************************************

// iOS 하이브리드앱에서 LocalStorage 미작동에 대한 대응 통신 (네이티브에 저장)
// 데이터 필요시 , get을 날린 후, sessionStorage에 저장이 됐을 때, read로 꺼내 사용해야 함.
export const AppBridge = {
  init () {
    let UA = navigator.userAgent.toLowerCase()
    if (UA.indexOf('ios') > -1 && UA.indexOf('native') > -1) {
      this.device = 'ios'
    } else if (UA.indexOf('aos') > -1 && UA.indexOf('native') > -1) {
      this.device = 'aos'
    } else {
      this.device = 'desktop'
    }
  },

  get (name) {
    this.init()
    let data = JSON.stringify({ 'type': 'get', 'name': name})
    
    if (this.device === 'ios') {
      // eslint-disable-next-line
      webkit.messageHandlers.AppBridge.postMessage(data)
    } else if (this.device === 'aos') {
      window.SLLAndroid.AppBridge(data)
    } else {
      // 상품 진열 정보 deskTop시 default값 설정
      if (name === 'wzdPrdtCol' && !localStorage.getItem('wzdPrdtCol')) {
        // console.log(JSON.stringify({value: 0}))
        localStorage.setItem(name, JSON.stringify({value: 1}))
        window.setSllPrdtCol(localStorage.getItem('wzdPrdtCol'))
      } else if (name === 'wzdPrdtCol' && localStorage.getItem('wzdPrdtCol')) {
        window.setSllPrdtCol(localStorage.getItem('wzdPrdtCol'))
      }

      if (name === 'vodPrdtCol' && !localStorage.getItem('vodPrdtCol')) {
        // console.log(JSON.stringify({value: 0}))
        localStorage.setItem(name, JSON.stringify({value: true}))
        window.setVodPrdtCol(localStorage.getItem('vodPrdtCol'))
      } else if (name === 'vodPrdtCol' && localStorage.getItem('vodPrdtCol')) {
        window.setVodPrdtCol(localStorage.getItem('vodPrdtCol'))
      }

    }
  },

  send (name, param, isAos) {
    // VodPipExit, LivePipExit, VodScreenStatus, liveInfo, visibleBtmNavBar, tracking, botNavPrdt
    this.init()
    let data = JSON.stringify({ 'type': 'send', 'name': name, 'value': param })
    // alert(data)
    console.log('bridge name: ', name, 'param: ', param)

    if (this.device === 'ios') {
      // eslint-disable-next-line
      webkit.messageHandlers.AppBridge.postMessage(data)
      
    } else if (this.device === 'aos' && isAos) {
      window.SLLAndroid.AppBridge(data)
    }

    // 방송 pip, full 사이즈가 변경 될 때마다 브릿지로 바텀 네비게이션 바 통신
    if (name === 'VodPipExit' || name === 'LivePipExit' || name === 'VodScreenStatus' || name === 'liveInfo') {
      let b = {value: false}
      if (name === 'VodScreenStatus') {
        console.log(param)
        b.value = param.value 
      }
      if (name === 'liveInfo' || name === 'LivePipExit' || name === 'VodPipExit') {
        b.value = true
      }

      let btmData = JSON.stringify({ 'type': 'send', 'name': 'visibleBtmNavBar', 'value': b })

      if (this.device === 'ios') {
        // eslint-disable-next-line
        webkit.messageHandlers.AppBridge.postMessage(btmData)
        
      } else if (this.device === 'aos') {
        window.SLLAndroid.AppBridge(btmData)
      }
    }

  },

  set (name, param) {
    // saveUser, setWebLanguage
    this.init()
    let data = JSON.stringify({ 'type': 'set', 'name': name, 'value': param })
    if (this.device === 'ios') {
      // eslint-disable-next-line
      webkit.messageHandlers.AppBridge.postMessage(data)
    }
    else if (this.device === 'aos') {
      if (name === 'setWebLanguage') {
        window.SLLAndroid.AppBridge(data)
      }
    }
    
    localStorage.setItem(name, param)
  },

  delete (name) {
    this.init()
    if (this.device === 'ios') {
      let data = JSON.stringify({ 'type': 'delete', 'name': name })
      // eslint-disable-next-line
      webkit.messageHandlers.AppBridge.postMessage(data)
    }
  },

  // 네이티브에서 웹으로 수신받기 위한 함수. 사용시 컴포넌트 내부의 create나 mount 사이클에 window.receiveApp =  AppBridge.receiveApp 로 전역설정을 해줘야 함.
  receiveApp (name, obj) {
    switch (name) {
      // 자동로그인 브릿지. IOS만 사용
      case 'saveUser':
        if (obj !== '') {
          sessionStorage.setItem(name, obj)
        } else {
          sessionStorage.setItem('setGroupChk', JSON.stringify({id: '0', flag: false}))
        }
        break

      // 상품진열버튼 브릿지. IOS 만 사용
      case 'wzdPrdtCol':
        window.setSllPrdtCol(obj)
        break

      // 다시보기 상품리스트버튼 브릿지.
      case 'vodPrdtCol' :
        window.setVodPrdtCol(obj)
        break

      // 셀러버 계약 newBadge IOS만 사용
      case 'pastContractList' :
        // window.setContractList(obj)
        if (obj !== '') {
          sessionStorage.setItem(name, obj)
        }
        break

      case 'phoneNameChk' :
        if (obj !== '') {
          sessionStorage.setItem(name,obj)
        }
        break

      // 토큰 갱신용 브릿지. 안드로이드, 아이폰 공통 사용
      case 'refreshToken':
        if (sessionStorage.getItem('refreshToken')) {
          getAccessToken(sessionStorage.getItem('refreshToken'))
            .then(res => {
              if (res.data.jsonData.resultCode === '0001') {
                sessionStorage.setItem('accessToken', res.data.jsonData.accessToken)

                let UA = navigator.userAgent.toLowerCase()
                
                let data = JSON.stringify({'type': 'send', 'name': 'accessToken', 'value': {'value': res.data.jsonData.accessToken}})
                if (UA.indexOf('ios') > -1 && UA.indexOf('native') > -1) {
                  // eslint-disable-next-line
                  webkit.messageHandlers.AppBridge.postMessage(data)
                } else if (UA.indexOf('aos') > -1 && UA.indexOf('native') > -1) {
                  window.SLLAndroid.AppBridge(data)
                }
                
                window.TokenService._setToken()
              }
            })
            .catch(err => {
              console.log(err)
            })
        } else {
          console.log('비로그인 상태')
        }
        break

      // 페이지 이동 브릿지. 안드로이드, ISO 공통 사용
      // 호출 형태 : AppBridge.receiveApp('redirectPrdt', '{"value": "169"}')
      case 'redirectPrdt':
        if (obj !== '') {
          window.routeGo(obj)
        }
        break
      
      case 'brandSysId':
        if(obj !== '') {
          window.routeGo2(obj)
        }
        break

      // 라이브 화면이 종료되었다는 콜백 브릿지
      case 'liveExit':
        if(obj !== '') {
          window.liveExit(obj)
        }
        break

      case 'vodPipAnim':
        if (obj !== '') {
          if(window.pastVodPip) {
            window.switchPipMode(obj)
          } else {
            return false
          }
        }
        break

      // 모바일 송출 종료 브릿지
      case 'StreamExit':
        if (obj !== '') {
          if (window.streamExit) {
            window.streamExit(obj)
          }
        }
        break

      case 'ContactsData':
        if (obj !== '') {
          if(window.contactsData) {
            window.contactsData(obj)
          }
        }
        break

      case 'getNotificationTopic':
        if (obj !== '') {
          if(window.getNotificationTopic) {
            window.getNotificationTopic(obj)
          }
        }
        break

      case 'setWebLanguage':
        if (obj !== '') {
          if(window.setWebLanguage) {
            window.setWebLanguage(obj)
          }
        }
        break

      case 'tabselect':
        if (obj !== '') {
          if (window.routerBridge) {
            window.routerBridge(obj)
          }
        }
      break

      case 'setLandingPage':
        if (obj !== '') {
          sessionStorage.setItem('landingPage', JSON.parse(obj).value)
        }
      break

      case 'notch':
        if (obj !== '') {
          if (window.setNotch) {
            window.setNotch(obj)
          }
        }
      break


      default:
        break
    }
  },

  read: async name => {
    return new Promise ((res, rej) => {
      let timer
      let int = setInterval(() => {
        if (sessionStorage.getItem(name)) {
          clearInterval(int)
          clearTimeout(timer)
          res(sessionStorage.getItem(name))
        }
      }, 300)

     timer = setTimeout(() => {
        clearInterval(int)
        res('')
      }, 1500)
    })
  }


}

